const clearSessionStorage = (): void => {
  const correlationId = sessionStorage.getItem('correlationId')
  const lwsRedirectUri = sessionStorage.getItem('lwsRedirectUri')

  sessionStorage.clear()

  sessionStorage.setItem('correlationId', correlationId)

  if (lwsRedirectUri) {
    sessionStorage.setItem('lwsRedirectUri', lwsRedirectUri)
  }
}

export default clearSessionStorage
